module.exports = __webpack_public_path__ + "img/SKMJ_cost.d458b3dc.png";